export enum ColorScheme {
    LIGHT = 'light',
    DARK = 'dark'
}

export const COLOR_SCHEME_LOCAL_STORAGE_KEY = 'prefers-color';
